import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OpcionesPerfilRolDto } from 'src/app/core/data/OpcionesPerfilRolDto';
import { opciones } from 'src/app/core/data/rolOpciones';
import { SubjectsService } from 'src/app/core/services/subjects.service';
import { AutenticacionStoreService } from 'src/app/feature/autenticacion/store/autenticacion-store.service';

@Component({
  selector: 'app-titulo-informativo-opciones',
  templateUrl: './titulo-informativo-opciones.component.html',
  styleUrls: ['./titulo-informativo-opciones.component.css']
})
export class TituloInformativoOpcionesComponent implements OnInit {

  // COM Elementos opciones
  @ViewChild('otrosProductos') otrosProductosVc?: ElementRef;
  @ViewChild('quinte') quinteVc?: ElementRef;
  @ViewChild('premiosQuinte') premiosQuinteVc?: ElementRef;
  @Input() titulo: string;

  // COM Roles perfil
  public perfiles$: Observable<OpcionesPerfilRolDto>;
  public perfiles: OpcionesPerfilRolDto;
  public constantesOpciones = opciones;

  // COM Estado de opciones
  public otrosProductos = false;
  public quinte = false;

  public ventasQuinte = false;
  public ventasOtrosProductos = false;
  public premiosQuinte = false;
  public anuladosQuinte = false;

  //  COM Redirecciones
  public opcionesVentas = false;
  public opcionesPremios = false;
  public opcionesAnulados = false;

  public pathRedireccion: string;

  constructor(
    private subjectService: SubjectsService,
    private readonly renderer: Renderer2,
    private router: Router,
    private autenticacionStoreService: AutenticacionStoreService) {
      this.obtenerPerfilRol();
    }

  ngOnInit(): void {
    this.validarOpcion();
  }

  validarOpcion() {
    this.subjectService.pathTituloInformativoGet.subscribe({
      next: (path: string) => {
        this.pathRedireccion = path;
        this.validarModulos();
        this.opcionSeleccionada(path);
      }
    });
  }

  opcionSeleccionada(opcion: string) {
      if(this.opcionesVentas === true) {
        switch (opcion) {
          case 'ventaLoteriaOtrosProductos':
            this.router.navigate(['reporte/venta-loterias-y-otros-productos']);
            break;
          case 'ventasQuinte':
            this.router.navigate(['reporte/ventas-quinte']);
            break;
        }
      }
      if(this.opcionesPremios === true) {
        switch (opcion) {
          case 'premiosQuinte':
            this.router.navigate(['reporte/premios-quinte']);
            break;
        }
      }
      if(this.opcionesAnulados === true) {
        switch (opcion) {
          case 'anuladosQuinte':
            this.router.navigate(['reporte/anulados-quinte']);
            break;
        }
      }
  }

  validarModulos() {
    this.cancelarModulos();
    this.cancelarVentanas();



    switch (this.pathRedireccion) {
      case 'ventasQuinte':
        this.opcionesVentas = true;
        this.ventasQuinte = true;
        break;
      case 'ventaLoteriaOtrosProductos':
        this.opcionesVentas = true;
        this.ventasOtrosProductos = true;
        break;
      case 'premiosQuinte':
        this.opcionesPremios = true;
        this.premiosQuinte = true;
        break;
      case 'anuladosQuinte':
        this.opcionesAnulados = true;
        this.anuladosQuinte = true;
        break;
    }
  }

  cancelarModulos(): void {
    this.opcionesVentas = false;
    this.opcionesPremios = false;
    this.opcionesAnulados = false;
  }

  cancelarVentanas() {
    this.ventasOtrosProductos = false;
    this.ventasQuinte = false;
    this.premiosQuinte = false;
    this.anuladosQuinte = false;
  }

  public obtenerPerfilRol(): void {
    this.perfiles$ = this.autenticacionStoreService.obtenerPerfiles$();
    this.perfiles = new OpcionesPerfilRolDto();
  }

  public validarOpcionRol(valor: number): boolean {
    this.perfiles$.subscribe((data: OpcionesPerfilRolDto) => {
      this.perfiles = data;
    });

    return Object.values(this.perfiles).includes(valor);
  }
}
